export var DATA_KEY = "ef.collapsible";
export var EVENT_KEY = ".".concat(DATA_KEY);
export var events = {
  SHOWN: "".concat(EVENT_KEY, ".shown"),
  HIDDEN: "".concat(EVENT_KEY, ".hidden")
};
export var aria = {
  EXPANDED: "aria-expanded",
  HIDDEN: "aria-hidden",
  CONTROLS: "aria-controls"
};
export var defaultConfig = {
  breakpoints: [],
  collapsed: true,
  toggleText: ""
};